import React, {memo, useCallback, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {DoorModel} from '../../../../types/door';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useRPC} from '../../../../hooks/rpc';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: DoorModel) => item.id;

export const DoorListScreen = memo(function DoorListScreen() {
    const [rpc] = useRPC();
    const {t} = useLocalization();
    const doorList = useSelector(state => state.control.doorList);
    const doorBrandSet = useSetSelector(state => state.control.doorBrandList);

    const [selectedDoor, setSelectedDoor] = useState<DoorModel>(null);

    const onTestClick = useCallback(() => {
        rpc.openDoor(selectedDoor.id)
    }, [selectedDoor, rpc])

    const buttons = useMemo(() => [
        {
            text: t('test'),
            onClick: onTestClick,
            className: 'blue',
            hidden: !(selectedDoor),
        },
        {
            text: t('edit'),
            url: `/settings/door/edit/${selectedDoor ? selectedDoor.id : ''}`,
            className: 'orange',
            hidden: !(selectedDoor),
        },
        {
            text: t('create_door'),
            url: '/settings/door/edit',
            className: 'green',
        },
    ], [t, selectedDoor, onTestClick]);


    const displayNameExtractor = useCallback((item: DoorModel, column: ColumnModel) => {
        if (column.key === 'door_brand_id') {
            return doorBrandSet[item.door_brand_id].name;
        }

        return item[column.key] || '-';
    }, [doorBrandSet]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('door_name'),
            key: 'name',
        },
        {
            length: 1,
            name: t('brand'),
            key: 'door_brand_id',
        },
        {
            length: 2,
            name: t('url'),
            key: 'door_path',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={doorList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedDoor}
                    onItemSelected={setSelectedDoor}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
